import { ABOUT_POINTS, TESTIMONIALS } from "../../../mocks/gossip";
import { SectionHead } from "./Shared";

export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full bg-background-100/70 py-10 md:py-14"
      aria-label="关于每日瓜料"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          {/* brand intro */}
          <div className="lg:col-span-5">
            <SectionHead
              eyebrow="ABOUT US"
              anchor="about"
              title="关于每日瓜料"
              desc="我们是一群喜欢把热点讲清楚的内容人。每天三档更新、突发实时跟进，用时间线和分类让每一个瓜都看得明明白白。"
            />
            <p className="text-sm leading-7 text-foreground-600 md:text-[15px]">
              从立项第一天起，「先求证、再发布」就是我们写进原则里的底线。面对真假难辨的爆料，我们会尽力还原时间线与各方口径，能确认的标注证据，拿不准的清楚写明「求证中」，绝不让情绪和流量替事实作主。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <a
                href="#join"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                加入每日追瓜 <i className="ri-send-plane-line" />
              </a>
              <a
                href="mailto:contact@meirigualiao.com"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-mail-line" /> 联系我们
              </a>
            </div>
          </div>

          {/* principles */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-7">
            {ABOUT_POINTS.map((p, i) => (
              <div
                key={i}
                className="flex items-start gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className={`${p.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-sm leading-6 text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* testimonials 口碑 */}
        <div className="mt-10 border-t border-background-200/80 pt-8 md:pt-10">
          <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
            <h3 className="flex items-center gap-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
              <i className="ri-heart-3-fill text-primary-500" />
              读者怎么评价我们
            </h3>
            <span className="inline-flex items-center gap-1 text-sm font-semibold text-accent-700">
              <i className="ri-star-fill text-accent-500" />
              4.9 / 5 · 来自 1.2 万条真实反馈
            </span>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {TESTIMONIALS.map((t, i) => (
              <figure
                key={i}
                className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <i key={s} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">
                  「{t.text}」
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/80 pt-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-label text-sm font-bold text-background-50">
                    {t.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{t.name}</span>
                    <span className="block text-xs text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}